module.exports = __webpack_public_path__ + "static/media/chevron-down-active.95e2362a.svg";